export default __webpack_public_path__ + "content/GothamSSm-Medium_Web.woff2";